import React, {useState} from 'react';
import '../styles/CustomTooltip.css';
import {FormattedMessage} from 'react-intl';

const CustomTooltip = ({tooltipMessageId, children}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="tooltip-container"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="tooltip-trigger">{children}</div>

      {isHovered && tooltipMessageId && (
        <div className="tooltip-text">
          <FormattedMessage id={tooltipMessageId} />
        </div>
      )}
    </div>
  );
};

export default CustomTooltip;
